import NoDataComponent from "../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const foreign_workers_no_data = (props) => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Foreign Workers"
      subheaderinfo="Foreign Workers will appear here"
    />
  );
};

export default foreign_workers_no_data;
